import {useAppDispatch} from "../../../../hooks/hooks";
import {useCallback} from "react";
import {OrganShareAllocateDTO} from "../../../../types/organShare";
import {allocateAuthorityAsync} from "../../../../store/organShareSlice";
import {useUtil} from "../../../../util/hooks/useUtil";

export function useOrganManagerShareActions() {
    const dispatch = useAppDispatch();
    const {defaultErrorMessage} = useUtil();

    // 소속 정보 리스트
    const allocateAuthority = useCallback(
        async (dto: OrganShareAllocateDTO) => {
            try {
                await dispatch(allocateAuthorityAsync(dto)).unwrap();
                window.alert("읽기 권한 부여 완료했습니다.")
            } catch (e) {
                alert(defaultErrorMessage);
            }
        },
        //eslint-disable-next-line
        []
    );

    return{
        allocateAuthority
    }
}